import { registerEffects, removeEffects } from '@ngneat/effects';
import { useEffect, useMemo, useInsertionEffect } from 'react';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

function useEffects(effects) {
  useEffect(() => {
    registerEffects(effects);
    return () => {
      removeEffects(effects);
    };
  }, [effects]);
}

function useEffectFn(effects) {
  const {
    destroyed
  } = useUntilDestroyed();
  const result = useMemo(() => {
    const toArray = Array.isArray(effects) ? effects : [effects];
    return toArray.map(e => e(destroyed));
  }, [destroyed, effects]);
  return Array.isArray(effects) ? result : result[0];
}

function useUntilDestroyed() {
  const subject = useMemo(() => new Subject(), []);
  const data = useMemo(() => ({
    untilDestroyed() {
      return takeUntil(subject.asObservable());
    },

    destroyed: subject.asObservable()
  }), [subject]);
  useInsertionEffect(() => {
    return () => subject.next(true);
  }, [subject]);
  return data;
}

export { useEffectFn, useEffects };
